const faqCardSelector = "[class^='gozo-faq-card-']";

document.addEventListener(
  'toggle',
  (event) => {
    const currentDetails = event.target;

    if (!(currentDetails instanceof HTMLDetailsElement)) return;
    if (!currentDetails.open || !currentDetails.closest(faqCardSelector)) return;

    document.querySelectorAll(`${faqCardSelector} details[open]`).forEach((details) => {
      if (details !== currentDetails) details.open = false;
    });
  },
  true
);
